import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withKeys as _withKeys } from "vue";
const _hoisted_1 = { class: "grey lighten-5 px-4 py-4" };
const _hoisted_2 = { class: "require-field-wrapper pb-4" };
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = { class: "wh-pl" };
const _hoisted_5 = {
    key: 0,
    class: "text-body-1 pb-0 mx-4"
};
import { globalAlertType } from '@/constants/global';
import { computed } from 'vue';
import { i18n } from '@/locales';
import { getGlobalStore } from '@/lib/global-store';
import DialogFooter from '@/components/Dialog/DialogFooter.vue';
import DialogHeader from '@/components/Dialog/DialogHeader.vue';
import { alertActionType } from '@/vuex-store/alert/actions';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Alert',
    setup(__props) {
        const vuexStore = getGlobalStore();
        const open = computed(() => vuexStore.state.alert.open);
        const headerTitle = computed(() => vuexStore.state.alert.headerTitle);
        const bodyContent = computed(() => vuexStore.state.alert.bodyContent);
        const alertType = computed(() => vuexStore.state.alert.alertType);
        const selectedItem = computed(() => vuexStore.state.alert.selectedItem);
        const resolve = computed(() => vuexStore.state.alert.resolve);
        const btnConfig = computed(() => vuexStore.state.alert.btnConfig);
        const bodyContentHtml = computed(() => vuexStore.state.alert.bodyContentHtml);
        const formattedHeaderTitle = computed(() => (headerTitle.value ? i18n.t(headerTitle.value) : headerTitle.value));
        const formattedBodyContent = computed(() => (bodyContent.value ? i18n.t(bodyContent.value) : bodyContent.value));
        const showAlert = computed(() => alertType.value === globalAlertType.ALERT);
        const showConfirm = computed(() => alertType.value === globalAlertType.CONFIRM);
        const showRemove = computed(() => alertType.value === globalAlertType.REMOVE);
        const dialog = computed({
            get() {
                return open.value;
            },
            set() {
                // @ts-ignore
                vuexStore.dispatch(alertActionType.close);
            },
        });
        const handleClickNo = () => {
            resolve.value(false);
            // @ts-ignore
            vuexStore.dispatch(alertActionType.close);
        };
        const handleClickOk = () => {
            resolve.value(true);
            // @ts-ignore
            vuexStore.dispatch(alertActionType.close);
        };
        return (_ctx, _cache) => {
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_dialog = _resolveComponent("v-dialog");
            return (_openBlock(), _createBlock(_component_v_dialog, {
                "data-cy": "alert",
                modelValue: dialog.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((dialog).value = $event)),
                "content-class": "responsive-dialog",
                onKeydown: [
                    _withKeys(handleClickNo, ["esc"]),
                    _withKeys(handleClickOk, ["enter"])
                ]
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_card, null, {
                        default: _withCtx(() => [
                            _createVNode(DialogHeader, {
                                title: formattedHeaderTitle.value,
                                "on-cancel": handleClickNo
                            }, null, 8 /* PROPS */, ["title"]),
                            _createCommentVNode(" BODY"),
                            _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    _createVNode(_component_v_card_title, { class: "text-body-1 pb-0 text-black" }, {
                                        default: _withCtx(() => [
                                            _createCommentVNode(" html형태로 보내는 bodycotent "),
                                            _createElementVNode("div", {
                                                innerHTML: bodyContentHtml.value,
                                                class: "wh-pl"
                                            }, null, 8 /* PROPS */, _hoisted_3),
                                            _createElementVNode("span", _hoisted_4, _toDisplayString(formattedBodyContent.value), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }),
                                    (selectedItem.value)
                                        ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                                            _createElementVNode("li", null, _toDisplayString(selectedItem.value), 1 /* TEXT */)
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ]),
                            _createVNode(_component_v_divider),
                            _createCommentVNode(" alert type (버튼 하나)"),
                            (showAlert.value)
                                ? (_openBlock(), _createBlock(DialogFooter, {
                                    key: 0,
                                    ok: "",
                                    "on-ok": handleClickNo
                                }))
                                : _createCommentVNode("v-if", true),
                            _createCommentVNode(" confirm type (버튼 두개)"),
                            (showConfirm.value)
                                ? (_openBlock(), _createBlock(DialogFooter, {
                                    key: 1,
                                    "show-shortcut": "",
                                    ok: "",
                                    cancel: "",
                                    "on-cancel": handleClickNo,
                                    "on-ok": handleClickOk,
                                    "btn-config": btnConfig.value
                                }, null, 8 /* PROPS */, ["btn-config"]))
                                : _createCommentVNode("v-if", true),
                            _createCommentVNode(" confirm type (버튼 두개)"),
                            (showRemove.value)
                                ? (_openBlock(), _createBlock(DialogFooter, {
                                    key: 2,
                                    cancel: "",
                                    remove: "",
                                    "on-cancel": handleClickNo,
                                    "on-remove": handleClickOk
                                }))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"]));
        };
    }
});
